export { getHomePage } from "./getHomePage";
